module.exports = __webpack_public_path__ + "img/right-leg_active.a57e66ab.png";